/*
* ラジオボタンの重複チェック
*/

export default class DuplicationCheck {
  constructor() {
    this.$formItem = document.querySelectorAll('[data-form="validation"]');
  }

  attachEvent() {

    Array.prototype.forEach.call( this.$formItem, $item => {
      $item.addEventListener('change', () => {
        validation();
      });
    });

    window.addEventListener('pageshow', () => {
      validation();
    });

    function validation() {
      const $formSubmit = document.querySelector('[data-form="submit"]');

      if ($formSubmit) {
        const formItemArray = [].slice.call(document.querySelectorAll('[data-form="validation"]'));
        const result = formItemArray.filter(item => item.checked).every((val, index, arr) => {
          return arr[0].value === arr[index].value;
        });

        if (result) {
          $formSubmit.disabled = true;
        } else {
          $formSubmit.disabled = false;
        }
      }
    }
  }
}
